/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_PageInputs */

const en_loading_page = /** @type {(inputs: Loading_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading page`)
};

const pt_br2_loading_page = /** @type {(inputs: Loading_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando página`)
};

/**
* | output |
* | --- |
* | "Loading page" |
*
* @param {Loading_PageInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const loading_page = /** @type {((inputs?: Loading_PageInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_PageInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loading_page(inputs)
	return pt_br2_loading_page(inputs)
});